import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "./api";
import { useAuthStore } from "../store/auth";
import { flushPendingUnits } from "./unit-progress";

// 送れなかったユニット完了を、アプリを開いた時とオンラインに戻った時に送る
export function useFlushPendingUnits() {
  const userId = useAuthStore((s) => s.user?.id ?? null);
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!userId) return;
    const run = () => {
      void flushPendingUnits(
        userId,
        (unitId, answers) => api(`/api/learner/units/${unitId}/complete`, { method: "POST", body: { answers } }),
        // 送っている途中で別の人に切り替わったら、その人のトークンで送らない
        () => useAuthStore.getState().user?.id === userId,
      ).then((n) => {
        if (n > 0) void queryClient.invalidateQueries();
      });
    };
    run();
    window.addEventListener("online", run);
    return () => window.removeEventListener("online", run);
  }, [userId, queryClient]);
}
